import React, { useState, useEffect, forwardRef } from "react";
import axios from "axios";
import "./MarketingForm.css";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

const DocladderFilterMarketingValue = forwardRef(({ onResults }, ref) => {
  const [query, setQuery] = useState("");
  const [location, setLocation] = useState("");
  const [state, setState] = useState("");
  const [category, setCategory] = useState("");
  const [activeStatus, setActiveStatus] = useState("");
  const [source, setSource] = useState("");
  const [percentageClosed, setPercentageClosed] = useState("");
  const [vacancy, setVacancy] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [loading, setLoading] = useState(false);
  const [sources, setSources] = useState([]);
  const [loadingSources, setLoadingSources] = useState(false);
  const [sourcesLoaded, setSourcesLoaded] = useState(false);

  // Call onResults whenever any filter is changed
  useEffect(() => {
    const filters = {
      query,
      location,
      state,
      category,
      activeStatus,
      source,
      percentageClosed,
      selectedMonth,
      selectedYear,
    };
    onResults(filters);
  }, [
    query,
    location,
    state,
    category,
    activeStatus,
    source,
    percentageClosed,
    selectedMonth,
    selectedYear,
  ]);

  const months = [
    { name: "January", value: 1 },
    { name: "February", value: 2 },
    { name: "March", value: 3 },
    { name: "April", value: 4 },
    { name: "May", value: 5 },
    { name: "June", value: 6 },
    { name: "July", value: 7 },
    { name: "August", value: 8 },
    { name: "September", value: 9 },
    { name: "October", value: 10 },
    { name: "November", value: 11 },
    { name: "December", value: 12 },
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

  // Fetch sources when the user clicks on the dropdown
  const fetchSources = async () => {
    if (!sourcesLoaded) {
      setLoadingSources(true);
      try {
        const response = await axios.get(
          getApiUrl("/DocladderFiles/FilterDocladderMarketingValue/")
        );
        setSources(response.data);
        setSourcesLoaded(true);
      } catch (error) {
        console.error("There was an error fetching the sources!", error);
      } finally {
        setLoadingSources(false);
      }
    }
  };

  return (
    <div className="filter-marketing-value p-4" style={{ width: "90%", margin: 'auto' }}>
      {/* <h2 className="text-2xl font-semibold mb-3 text-center text-blue-700">Filter Marketing Files</h2> */}

      {/* First Row */}
      <div className="grid grid-cols-5 gap-2 mt-3 mb-2">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search by Client Name"
          className="input-field"
        />
        <input
          type="text"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          placeholder="Search by Location"
          className="input-field"
        />
        <input
          type="text"
          value={state}
          onChange={(e) => setState(e.target.value)}
          placeholder="Search by State"
          className="input-field"
        />
        <input
          type="text"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          placeholder="Search by Category"
          className="input-field"
        />
        <input
          type="text"
          value={percentageClosed}
          onChange={(e) => setPercentageClosed(e.target.value)}
          placeholder="Search by Percentage Closed"
          className="input-field"
        />
      </div>

      {/* Second Row */}
      <div className="grid grid-cols-4 gap-4">
        <select
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(e.target.value)}
          className="input-field"
        >
          <option value="">Select a month</option>
          {months.map((month) => (
            <option key={month.value} value={month.value}>
              {month.name}
            </option>
          ))}
        </select>

        <select
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
          className="input-field"
        >
          <option value="">Select a year</option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>

        <select
          value={activeStatus}
          onChange={(e) => setActiveStatus(e.target.value)}
          className="input-field"
        >
          <option value="">Select Active Status</option>
          <option value="true">Active</option>
          <option value="false">Inactive</option>
        </select>

        <select
          value={source}
          onChange={(e) => setSource(e.target.value)}
          onFocus={fetchSources}
          className="input-field"
        >
          <option value="">Select Source</option>
          {loadingSources ? (
            <option value="">Loading...</option>
          ) : (
            sources.map((source) => (
              <option key={source.id} value={source.name}>
                {source.name}
              </option>
            ))
          )}
        </select>
      </div>
    </div>
  );
});

export default DocladderFilterMarketingValue;
